import { createContext, ReactNode, useContext } from 'react'
import { useUserWithLoadedState } from '~/hooks/user/useUser'
import { User } from '~/types/ResponseType'

// Type for the user data that will be shared
export interface UserData {
  user: User | null
  loaded: boolean
  isAuthenticated: boolean
  refetch: () => Promise<void>
}

// Create the context
const UserContext = createContext<UserData | null>(null)

// Provider component
interface UserProviderProps {
  children: ReactNode
}

export function UserProvider({ children }: UserProviderProps) {
  const { user, loaded, refetch } = useUserWithLoadedState()
  const isAuthenticated = !!user?.user_id

  return (
    <UserContext.Provider
      value={{
        user,
        loaded,
        isAuthenticated,
        refetch
      }}
    >
      {children}
    </UserContext.Provider>
  )
}

// Hook to use the context
export function useUserContext(): UserData {
  const context = useContext(UserContext)
  if (!context) {
    throw new Error('useUserContext must be used within a UserProvider')
  }
  return context
}
